'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = theme;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function theme(ComponentToWrap, componentName) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(_class, _React$Component);

        function _class() {
            _classCallCheck(this, _class);

            return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
        }

        _createClass(_class, [{
            key: 'render',
            value: function render() {
                var componentTheme = {};

                if (componentName) {
                    componentTheme = this.context.p24ComponentsTheme && this.context.p24ComponentsTheme[componentName] || {};
                }

                if (this.props.theme) {
                    if (process && process.env.NODE_ENV !== 'production') {
                        console.warn('P24 theme. Use style property instead theme for runtime customization. ' + componentName);
                    }
                }

                return _react2.default.createElement(ComponentToWrap, Object.assign({}, this.props, {
                    theme: Object.assign({}, this.context.p24ComponentsTheme, componentTheme, this.props.theme || {}, this.props.style || {})
                }));
            }

            // let’s define what’s needed from the `context`

        }]);

        return _class;
    }(_react2.default.Component), _class.contextTypes = {
        p24ComponentsTheme: _propTypes2.default.object
    }, _class.displayName = 'Theme(' + (ComponentToWrap.displayName || 'Component') + ')', _class.propTypes = {
        // TODO REMOVE! DEPRECATED, USE STYLE PROP INSTEAD
        theme: _propTypes2.default.object,
        style: _propTypes2.default.object
    }, _temp;
}